module.exports = "../../img/modal-close.svg?8816827b02ad0f41cf6ea9c975b35bdd";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/proofs/index/components/PreOrderSearchEmail/assets/modal-close.svg
// module id = 750
// module chunks = 1